import React from "react";

import { SortListStandard, SortModalStandard } from "components/service";


const DamageSortModal = ({ sort }) => {

    const sortValues = [
        {
            label: "SORT.Text_HallAZ",
            value: { relStand: { aggregate: "MIN", column: "HALL_NAME" }, order: "ASC" }
        },
        {
            label: "SORT.Text_HallZA",
            value: { relStand: { aggregate: "MIN", column: "HALL_NAME" }, order: "DESC" }
        },
        {
            label: "SORT.Text_StandNumberAZ",
            value: { relStand: { aggregate: "MIN", column: "STAND_NUMBER" }, order: "ASC" }
        },
        {
            label: "SORT.Text_StandNumberZA",
            value: { relStand: { aggregate: "MIN", column: "STAND_NUMBER" }, order: "DESC" }
        },
        {
            label: "SORT.Text_ExhibitorNameAZ",
            value: { relStand: { aggregate: "MIN", column: "EXHIBITOR" }, order: "ASC" }
        },
        {
            label: "SORT.Text_ExhibitorNameZA",
            value: { relStand: { aggregate: "MIN", column: "EXHIBITOR" }, order: "DESC" }
        },
        {
            label: "SORT.Text_StatusAZ",
            value: { column: "STATUS", order: "ASC" }
        },
        {
            label: "SORT.Text_StatusZA",
            value: { column: "STATUS", order: "DESC" }
        },
    ];

    return (
        <SortModalStandard
            wrapClass="damage-sort-modal-wrap"
            modalClass="damage-sort-modal"
        >
            <SortListStandard
                sortValues={ sortValues }
                setQuerySort={ sort.set }
                defaultSort={ sort.data[0] }
            />
        </SortModalStandard>
    );
};

export default DamageSortModal;
